module.exports = __webpack_public_path__ + "static/img/dongguanwei1.f3a867c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dongguanwei1.png
// module id = 4cFN
// module chunks = 1